import React from "react";
import {Button} from 'react-bootstrap';
import coin from  "../../assets/images/withdraw/coin.svg";
import item1 from  "../../assets/images/withdraw/item3.png";
const CustomPrice = () => {
  return (
  <div className="trade-offer">



        <div className="selected-item-grid">

          <div className="selected-item-box">
            <div className="selected-item-cover">
                <img src={item1} alt="" />
            </div>
            <div className="selected-item-info">
              <div className="items-info">
                <span>Contraband Rifle</span>
                <h4>StatTrak™ M4A4 | Howl</h4>
              </div>
              <div className="items-category">Factory New</div>
              <div className="items-price">
                <h5><img src={coin} alt="" /> 1,258.00 <span>-65%</span></h5>
              </div>
            </div>
          </div>

        </div>


        <div className="custom-slider range">
                <input type="range" defaultValue={50} />
            </div>


            <div className="set-custom-price">
                <h4>Custom Price</h4>
                <div className="custom-price-input">
                    <input type="number" className="form-control" placeholder="+4%" />
                </div>
            </div>


        <div className="trade-offer-btn custom-btn">
            <Button>SET CUSTOM PRICE</Button>
        </div>




  </div>
  );
};

export default CustomPrice;
